import axios from "axios";
import store from "../store";
import router from "@/router";
import {Message} from "element-ui";
import {setLogin} from "../router";

// 全局表单提交方式
// 创建axios实例
const service = axios.create({
    baseURL: '/api/guard',
    withCredentials: true,
    headers: {
        // 'Cache-Control': 'no-cache',
        // 'Content-Type': 'application/json;charset=utf-8',
        // 'Pragma': 'no-cache'
    },
    // timeout: 75000
});    
 


service.interceptors.request.use((config) => {
    let headersObj=new Object();
    if(localStorage.getItem('accessTokenSys') ){
        headersObj["AccessTokenSys"]=localStorage.getItem('accessTokenSys');
    }

    headersObj["ClientAuth"]="Basic eGN3c19zdXBlcmFkbWluX3dlYjp4Y3dzX3N1cGVyYWRtaW5fd2ViX3NlY3JldGZnZHhzZA==";

    config.headers =headersObj;
    return config;
}, error => {
    console.log(error); // for debug
    Promise.reject(error);
})

// respone拦截器
service.interceptors.response.use(response => {
    let data = response.data;
    // console.log(data)
    if (data.code !== 200 && data.status !== true) {
        if(data.msg ) {
            Message({
                type: "warning",
                message: data.msg
            })
        } else {
            Message({
                type: "warning",
                message: '请求失败, 可能是网络问题'
            })
        }
    }
    if (data.code === 1000) {
        setLogin(false);
        store.dispatch('SET_USER', {})
        router.push({ path: '/login' })
    }
    if(data.data&&data.data.accessTokenSys){
        localStorage.setItem('accessTokenSys', data.data.accessTokenSys)
    }
    return data;
}, error => {
    if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        const response = error.response;
        const data = response.data;
        if (data && data.msg) {
            Message({
                type: "error",
                message: data.msg
            })
        } else {
            Message({
                type: "error",
                message: '请求失败, 可能是网络错误'
            })
        }
        return Promise.reject(response);
    } else {
        console.log('Error', error.message);
    }
    console.log(error.config);
});

export default service;
